<script lang="ts">
    import { db, type FileInfo } from "$lib/wasm/db";
    import { liveQuery } from "dexie";
    import { COMMANDS } from "$lib/commands";
    import { File } from "$lib/wasm/file";
    import { file as activeFile, onFilesUpdated } from "$lib/state";
    import FilePreview from "$lib/image/FilePreview.svelte";
    import Preview from "$lib/image/Preview.svelte";
    import IconCommandButton from "$lib/utility/IconCommandButton.svelte";

    console.debug("Create Files.svelte");

    let files = liveQuery(() => db.getFiles());

    function deleteFile(file: FileInfo) {
        File.delete(file);
    }

    async function setActiveFile(file: FileInfo) {
        if ($activeFile?.id === file.id) return;

        const newFile = await db.getFile(file.id, file);

        if (!newFile) return;

        COMMANDS.invoke("file.load", newFile);
    }

    $: sortedFiles = $files?.sort((a, b) => a.name.localeCompare(b.name)) ?? [];

    onFilesUpdated.onMount(() => {
        sortedFiles = sortedFiles;
    });
</script>

<!----------------------------------------------------------------------------->

<div class="files">
    {#each sortedFiles as file}
        {@const active = file.id === $activeFile?.id}
        <button
            class="file"
            class:active
            on:click={() => setActiveFile(file)}
        >
            <div class="preview">
                {#if active}
                    {#if $activeFile}
                        <Preview file={$activeFile} frame={0} />
                    {/if}
                {:else}
                    {#if file}
                        <FilePreview file="{file}" />
                    {/if}
                {/if}
            </div>

            <div class="info">
                <span class="name">{file.name}</span>
                <span class="size">{file.width}x{file.height}</span>
            </div>

            <div>
                <IconCommandButton on:click={(e) => { deleteFile(file); e.stopPropagation(); }} icon="delete-16" color="error" tooltip="Delete file"/>
            </div>
<!--            <button class="delete" on:click|stopPropagation={() => deleteFile(file)}-->
<!--            >-->
<!--                <Icon id="delete-16" />-->
<!--            </button-->
<!--            >-->
        </button>
    {/each}
</div>

<!----------------------------------------------------------------------------->

<style>
    .files {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(20em, 1fr));
        grid-auto-rows: max-content;
        gap: 0.25em;

        overflow-y: scroll;
        overflow-x: auto;
        height: 100%;
        width: 100%;
    }

    .file {
        all: unset;
        display: grid;
        grid-template:
                "preview info actions" max-content /
                max-content minmax(0, 1fr) max-content;
        padding: 0.125em;
    }

    .file:hover {
        background: var(--g200);

        & .name {
            color: var(--tacc);
        }
    }

    .preview {
        position: relative;
        height: 5em;
        width: 5em;

        & :global(canvas) {
            height: 5em;
            width: 5em;
            box-sizing: border-box;
            border: 1px solid var(--g100);
        }
    }

    .info {
        padding: 0.25em;
        display: flex;
        flex-direction: column;

        & .name {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            max-width: 100%;
        }

        & .size {
            font-size: 0.75em;
        }
    }


    .active {
        background: var(--g200);
    }

    .active .name {
        color: var(--tacc);
    }

    .delete {
        width: 1.5em;
        height: 1.5em;
        padding: 0;
        display: grid;
        place-content: center;
    }
</style>
